var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"kt_brand",staticClass:"brand flex-column-auto",attrs:{"id":"kt_brand"}},[_c('div',{staticClass:"brand-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticStyle:{"max-width":"130px"},attrs:{"src":_vm.siteLogo(),"alt":"Logo"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }